import styled from 'styled-components';
export const Footer = styled.div `
    width: 100%;
    display: ${({ shouldBeHidden }) => (shouldBeHidden ? 'none' : 'flex')};
    flex-direction: column;
    margin: 0 auto;
`;
Footer.displayName = 'Footer';
export const FooterButtonsContainer = styled.div `
    opacity: ${({ isSeeking }) => (isSeeking ? 0.2 : 1)};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 16px 0 32px;
`;
FooterButtonsContainer.displayName = 'FooterButtonsContainer';
export const FooterButtons = styled(FooterButtonsContainer) `
    & .PlayPauseButton-Button {
        margin-left: 0;
    }
`;
FooterButtons.displayName = 'FooterButtons';
//# sourceMappingURL=index.js.map